var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaximized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1289 21.9463C11.1289 22.3837 10.7743 22.7383 10.3369 22.7383L5.05671 22.7383C4.61928 22.7383 4.26468 22.3837 4.26468 21.9463L4.26468 16.6661C4.26468 16.2287 4.61928 15.8741 5.05671 15.8741C5.49413 15.8741 5.84873 16.2287 5.84873 16.6661L5.84873 21.1542L10.3369 21.1542C10.7743 21.1542 11.1289 21.5088 11.1289 21.9463Z",
    fill: "#404349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9502 11.1211C21.5127 11.1211 21.1581 10.7665 21.1581 10.3291L21.1581 5.84092L16.67 5.84092C16.2326 5.84092 15.878 5.48632 15.878 5.0489C15.878 4.61147 16.2326 4.25687 16.67 4.25687L21.9502 4.25687C22.3876 4.25687 22.7422 4.61147 22.7422 5.0489L22.7422 10.3291C22.7422 10.7665 22.3876 11.1211 21.9502 11.1211Z",
    fill: "#404349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0539 11.9477C14.7446 11.6384 14.7446 11.1369 15.0539 10.8276L21.3901 4.49141C21.6994 4.1821 22.2009 4.1821 22.5102 4.49141C22.8195 4.80071 22.8195 5.3022 22.5102 5.6115L16.174 11.9477C15.8647 12.257 15.3632 12.257 15.0539 11.9477Z",
    fill: "#404349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49531 22.5063C4.18601 22.197 4.18601 21.6955 4.49531 21.3862L10.8315 15.05C11.1408 14.7407 11.6423 14.7407 11.9516 15.05C12.2609 15.3593 12.2609 15.8608 11.9516 16.1701L5.61541 22.5063C5.3061 22.8156 4.80462 22.8156 4.49531 22.5063Z",
    fill: "#404349"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximized);
export default __webpack_public_path__ + "static/media/maximized.e5243f651c337e8334a9e992674fa541.svg";
export { ForwardRef as ReactComponent };